import React from "react";
import Image from "@herb/components/Image";
import { trackTransferToShop, trackSelectPromotion } from "../../../utils/analytics";
import { getOutboundLinkRel } from "@herb/utils";
import "./index.css";
import { fallbackImages } from "../../../utils/constants";

const DealProductHit = (hit, name) => {
  const deal = hit.hit ? hit.hit : hit;
  const {
    dealLink,
    product,
    customTitle,
    badgeText,
    badgeColor,
    badgeBackgroundColor,
    dealOffer,
    dealOfferColor
  } = deal?.contentDeals?.contentDeals || {};
  const title = customTitle || product?.title;
  const productImage =
    product?.contentProducts?.productImages?.[0]?.sourceUrl ||
    product?.images?.[0] ||
    "";
  const category = product?.category;
  const brand = product?.brand_name;
  const rel = getOutboundLinkRel({ brand });
  return product ? (
    <div className="dealProductCardAlgolia">
      <div className="dealProductCardImageDiv">
        <Image
          className="dealProductCardImageAlgolia"
          src={productImage}
          width={500}
        />
      </div>
      <div className="dealProductCardContentAlgolia">
        <p
          className={
            badgeText ? "dealProductCardPromoTextAlgolia" : "badgeTextEmpty"
          }
          style={
            badgeText
              ? { backgroundColor: badgeBackgroundColor, color: badgeColor }
              : undefined
          }
        >
          {badgeText ? badgeText : ""}
        </p>
        <p className="dealProductCardCategoryAlgolia">{category}</p>
        <p className="dealProductCardBrandAlgolia">{brand ? brand : ""}</p>
        <h5 className="dealProductCardTitleAlgolia">{title}</h5>
        <div
          className="dealProductCardPricesAlgolia"
          style={{
            visibility: dealOffer ? "visible" : "hidden"
          }}
        >
          <p
            className="dealProductCardDealPriceAlgolia"
            style={{ color: dealOfferColor }}
          >
            {dealOffer}
          </p>
        </div>
        <a
          className="dealProductCardLinkAlgolia"
          href={dealLink}
          target="_blank"
          rel={rel}
          onClick={() => {
            // Determine deal type from badge text
            let dealType = 'standard_deal';
            if (badgeText && badgeText.includes('%')) {
              dealType = 'percentage_off';
            } else if (badgeText && badgeText.includes('$')) {
              dealType = 'dollar_off';
            }
            
            // Track promotion selection
            trackSelectPromotion({
              promotionName: title,
              dealType: dealType,
              brand: brand || '',
              category: category || ''
            });
            
            // Track transfer to shop
            trackTransferToShop({
              affiliateUrl: dealLink,
              contentType: 'search_page',
              surfaceType: 'search_results',
              productTitle: title,
              category: category || '',
              brand: brand || ''
            });
          }}
        >
          Shop Now
        </a>
      </div>
    </div>
  ) : (
    ""
  );
};

export default DealProductHit;
